// Notifications bell — sourced verbatim from
//   design/UI : UX v1.0/for-engineering-shell/assets/icon-bell.svg
// Uses currentColor stroke so it inherits from the topbar text color.

import type { SVGProps } from 'react';

export function BellIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
      aria-label="Notifications"
      {...props}
    >
      <path
        d="M3 6.5C3 4 5 2 8 2C11 2 13 4 13 6.5V10L14 12H2L3 10V6.5Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 12.5C6.5 13.3 7.2 14 8 14C8.8 14 9.5 13.3 9.5 12.5"
        stroke="currentColor"
        strokeWidth="1.3"
      />
    </svg>
  );
}
